import { useEffect, useState } from "react";
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";
import ResponseComponent from "../../../../../components/responseComponent";
import QUDProgress from "../../../../../components/progress";
import { createAttributeValue, getAttributeValue, getAttributeValues, updateAttributeValue } from "../../../../../controllers/company/products/AttributesValuesController";

export default function AttributesValuesUpdate()
{
    const [attributeValue,setAttributeValue] = useState({});
    const [value,setValue] = useState('');
    const [errorValue,setErrorValue] = useState(false);

    const [description,setDescription] = useState('');
    const [errorDescription,setErrorDescription] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    const { attributeValueId, attributeId, attributeName } = useParams();

    useEffect(()=>{
        handleGetAttributeValue()
    },[]);


    const handleGetAttributeValue = async () => {
        const response = await getAttributeValue(attributeValueId);
        if(response.success === true)
        {
            setAttributeValue(response.data);
            setValue(response.data.value);
            setDescription(response.data.description);
        }
    }
    

    const formVerification = () => {
        let ban = 0;

        if(value === '')
        {
            setErrorValue(true);
            ban = 1;
        }

        if(description === '')
        {
            setErrorDescription(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await updateAttributeValue(attributeValue.id,value,description);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/attributes');
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo={'/products/attributes/values/'+attributeValue.attribute_id}
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Atributos',link:'/products/attributes'},
                    {name:'Valor',link:'/products/attributes/values/'+attributeValue.attribute_id},
                    {name:'Editar',link:'/products/attributesValues/update/'+attributeValue.id}
                ]}
            />
            <br/>
            <SectionTitle title={value} subtitle={'(Editar valor de atributo)'} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item md={6} lg={4} xl={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                label='Valor'
                                fullWidth
                                value={value}
                                onChange={(e)=>setValue(e.target.value)}
                                onBlur={()=>setErrorValue(value==='')}
                                error={errorValue}
                                helperText={errorValue?<Typography>El valor es obligatorio</Typography>:''}
                            />
                            
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                label='Descripción'
                                fullWidth
                                value={description}
                                onChange={(e)=>setDescription(e.target.value)}
                                onBlur={()=>setErrorDescription(value==='')}
                                error={errorDescription}
                                helperText={errorDescription?<Typography>La descripción es obligatorio</Typography>:''}
                            />
                            
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{mt:2}}
                                onClick={(e)=>handleSubmit(e)}
                            >
                                <Typography>Actualizar Valor</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}